import { render, staticRenderFns } from "./CreateProductMaster.vue?vue&type=template&id=4be95ece&"
import script from "./CreateProductMaster.vue?vue&type=script&lang=js&"
export * from "./CreateProductMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports